import { client } from './setup';
import { DISCOUNTS_API } from '../globals';

export default {
    getDiscounts: (params) => client.get(DISCOUNTS_API, { params }),
    createDiscounts: (discount) => client.post(DISCOUNTS_API, discount ),
    deleteDiscounts: (discountId) => client.delete(`${DISCOUNTS_API}/${discountId}`),
    updateDiscounts: (id, amount) => client.put(`${DISCOUNTS_API}/${id}`, { amount }),
}